import React, { Fragment } from 'react'
import data from '../PatientExperience.json';
import HeroSection from '../components/common/HeroSection';
import InfoCardGrid from '../components/common/InfoCardGrid';
import ImageCardGrid from '../components/common/WhyImageCard';
import ReviewCards from '../components/PatientExperience/ReviewCards';
import CTAPatientExp from '../components/PatientExperience/CTAPatientExp';

const { slides } = data.sections.hero;

const PatientExperience = () => {
    const categories = data.categories;
    const cta = data.cta;
    return (
        <Fragment>
            <HeroSection slides={slides} autoPlayInterval={13000} />

            <InfoCardGrid
                items={categories}
                bgClass='bg-blue-50/50'
            />
            <ImageCardGrid data={data.whyOurClinic} colsProp={6} cardClass="shadow-md" title={"Your experience, redefined."} />
            
            <ReviewCards />
            <CTAPatientExp items={cta.items} />
        </Fragment>
    )
}

export default PatientExperience